import { TenantsSpacesStrings } from '@general/helpers/SavedSearchesQuestionStrings';
import {
    getDisplaySize,
    getDisplayPurpose,
    getDisplayDensity,
    getDisplayCenter,
    getDisplayFacility,
} from '@general/entities/property';

import { getIsActive, getIsExpired, getIsExpiring, getIsNew } from '@general/helpers/propertyStatus.helpers';

export const mapSearchPropertyToProps = ({ hit, index, isFavorite, onClick }) => {
    // todo: if location will be stored with a newline character
    // splitting the address and city/state then this method
    // will work. Otherwise, using displayLocation is
    // probably best.
    // const [address1, address2] = hit.location.split('\n');

    let internalUrl = `/my-icsc/properties/${hit.manager.companyId}/${hit.manager.recordId}/${hit.objectID}`;
    if (index && hit.__queryID) {
        internalUrl += `?queryID=${hit.__queryID}&objectID=${hit.objectID}&index=${index}`;
    }

    return {
        hit,
        id: hit.objectID,
        recordId: hit.recordId,
        accuracy: hit.accuracy,
        activatedAt: hit.activatedAt,
        activations: hit.activations,
        // todo: uncomment or remove when comment above is solved
        // address1,
        // address2: address2.replace(/-\d{4}$/, ''),
        businesses: hit.businesses,
        coverPhotoUrl: hit.photos ? hit.photos.find(photo => photo.isCoverPhoto)?.url : null,
        description: hit.description,
        // Single string representing full address
        displayLocation: hit.location,
        events: hit.events,
        externalUrl: hit.url,
        expiresAt: hit.expiresAt,
        internalUrl,
        isFavorite,
        latitude: hit._geoloc.lat,
        longitude: hit._geoloc.lng,
        manager: hit.manager,
        onClick,
        objectID: hit.objectID,
        photos: hit.photos,
        populationDensity: getDisplayDensity(hit.density),
        purpose: getDisplayPurpose(hit.purpose),
        size: getDisplaySize(hit.size),
        squareFeet: hit.squareFeet,
        title: hit.title,
        typeOfCenter: getDisplayCenter(hit.typeOfCenter),
        typeOfFacility: getDisplayFacility(hit.typeOfFacility),
        updatedAt: hit.updatedAt,
        url: hit.url,
        isActive: getIsActive(hit.activatedAt),
        isNew: getIsNew({ activatedAt: hit.activatedAt, activations: hit.activations }),
        isExpired: getIsExpired(hit.expiresAt),
        isExpiring: getIsExpiring(hit.expiresAt),
    };
};

export const mapGraphPropertyToForm = ({ property, isFavorite, onClick }) => {
    const businesses = [];

    if (property.businesses) {
        property.businesses.forEach(business => {
            businesses.push(business.name);
        });
    }

    return {
        ...property,
        businesses,
        coverPhotoUrl: property.photos.find(photo => photo.isCoverPhoto)?.url,
        description: property.description,
        events: property.events ?? [],
        internalUrl: `/my-icsc/properties/${property?.manager?.company?.recordId}/${property?.manager?.recordId}/${property.id}`,
        listingManager: {
            label: `${property.manager?.firstName} ${property?.manager?.lastName}`,
            value: property.manager?.recordId,
        },
        listingManagerId: property.manager?.recordId,
        listingStatus: property.listingStatus || '',
        squareFeet: property.squareFeet || '',
        url: property.url ?? '',
        isFavorite,
        onClick,
    };
};

export const mapGraphPropertyToProps = ({ location, density, purpose, size, typeOfCenter, ...property }) => ({
    coverPhotoUrl: property.photos.find(photo => photo.isCoverPhoto)?.url,
    displayLocation: location,
    internalUrl: `/my-icsc/properties/${property?.manager?.company?.recordId}/${property?.manager?.recordId}/${property.id}`,
    populationDensity: TenantsSpacesStrings.density[density],
    purpose: TenantsSpacesStrings.purpose[purpose],
    size: TenantsSpacesStrings.size[size],
    typeOfCenter: TenantsSpacesStrings.typeOfCenter[typeOfCenter],
    ...property,
});
